import { cfetch } from '@confluence/network';

const AUTO_PROVISIONING_D0_EXPERIMENT_TRAIT_NAME = 'is_jira_confluence_d0_auto-provisioned';

type Trait = {
	name: string;
	value: string | boolean;
};

type UserTraitsState = {
	attributes: Trait[] | null;
};

const fetchPersonalizationSiteUserTraits = async (cloudId: string): Promise<UserTraitsState> => {
	const response = await cfetch(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`);
	return response.json();
};

export const getAutoProvisioningTapTrait = async (cloudId: string) => {
	if (!cloudId) {
		return null;
	}

	const siteUserTraitsData = await fetchPersonalizationSiteUserTraits(cloudId);
	if (!siteUserTraitsData || !siteUserTraitsData.attributes) {
		return null;
	}

	const trait = siteUserTraitsData.attributes.find(
		(att: Trait) => att.name === AUTO_PROVISIONING_D0_EXPERIMENT_TRAIT_NAME,
	);
	return trait ? trait.value : null;
};
